import React, { Component } from 'react';
import './Footer.scss';
import { UI_VERSION } from '../version';

export class Footer extends Component {
  static displayName = Footer.name;

  constructor(props) {
    super(props);
    this.state = {
      backendVersion: 'Loading...',
      environment: 'Loading...',
      loading: true
    };
  }

  componentDidMount() {
    this.fetchSystemInfo();
  }

  async fetchSystemInfo() {
    try {
      const response = await fetch('/api/system/version');
      if (response.ok) {
        const data = await response.json();
        this.setState({
          backendVersion: data.version ?? 'Unknown',
          environment: data.environment ?? 'Unknown',
          loading: false
        });
      } else {
        this.setState({
          backendVersion: 'Unknown',
          environment: 'Unknown',
          loading: false
        });
      }
    } catch (error) {
      console.error('Error fetching system info:', error);
      this.setState({
        backendVersion: 'Unknown',
        environment: 'Unknown',
        loading: false
      });
    }
  }

  render() {
    const { environment, loading, backendVersion } = this.state;

    return (
      <footer className="app-footer">
        <div className="footer-content">
          <div className="footer-left">
            <span>WaveWise</span>
          </div>
          <div className="footer-right">
            <span>UI: {UI_VERSION}</span>
            <span className="footer-separator">|</span>
            <span title={"Environment: " + (loading ? 'Loading...' : environment)}>Backend: {loading ? 'Loading...' : backendVersion}</span>
          </div>
        </div>
      </footer>
    );
  }
}
